import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { api } from '../api/client';

export type UserRole =
  | 'ADMIN'
  | 'MANAGER'
  | 'RECEPTION'
  | 'MODELLER'
  | 'CT_SPECIALIST'
  | 'PRINTER_OP'
  | 'WORKSHOP_LEAD'
  | 'POLISHER'
  | 'QC_INSPECTOR'
  | 'LOGISTICS'
  | 'ACCOUNTANT'
  | 'DOCTOR_PORTAL';

export interface User {
  id: string;
  email: string;
  fullName: string;
  role: UserRole;
  /** Tik klinikos portalo paskyrai */
  clinic?: { id: string; name: string } | null;
}

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null);
  const token = ref<string | null>(localStorage.getItem('ortholink_token'));

  const isAuthenticated = computed(() => !!token.value);

  async function login(email: string, password: string) {
    const { data } = await api.post('/auth/login', { email, password });
    token.value = data.token;
    user.value = data.user;
    localStorage.setItem('ortholink_token', data.token);
    return data;
  }

  async function fetchMe() {
    if (!token.value) return null;
    try {
      const { data } = await api.get('/auth/me');
      user.value = data;
      return data;
    } catch {
      logout();
      return null;
    }
  }

  function logout() {
    user.value = null;
    token.value = null;
    localStorage.removeItem('ortholink_token');
  }

  return {
    user,
    token,
    isAuthenticated,
    login,
    fetchMe,
    logout,
  };
});
